import { useTranslation } from "react-i18next";
import { Separator } from "@radix-ui/react-separator";
import { DynamicPopover } from "@/components/common/dynamic-popover";
import { AccountCard } from "@/components/common/account-card";
import { useI18nNavigate } from "@/hooks/use-i18n-navigate";
import { useLogout } from "@/hooks/use-logout";
import { iamAccountHooks } from "@/manager";
import {
  SettingsIcon,
  LogoutIcon,
} from "./assets";
import { UserInfo } from "./user-info";
import { MenuOptions } from "./menu-options";
import { SettingsAccountModal } from "../settings-account-modal";
import { useState } from "react";
import { AgentData } from "@/services/agent-list";

interface SettingsMenuProps {
  agent?: AgentData;
  isSubscribed: boolean;
}

export function SettingsMenu({
  agent,
  isSubscribed
}: SettingsMenuProps) {
  const logout = useLogout();
  const navigate = useI18nNavigate();
  const { t } = useTranslation();
  const { account } = iamAccountHooks.useData();

  const [accountModalOpen, setAccountModalOpen] = useState(false);

  const subName = agent?.subName || account?.email;

  const menuOptions = [
    {
      id: "settings",
      label: t("settings_menu.index.settings"),
      icon: <SettingsIcon />,
      shortcut: "",
      onClick: () => setAccountModalOpen(true),
      separator: true,
    },
    {
      id: "logout",
      label: t("settings_menu.index.logout"),
      icon: <LogoutIcon />,
      shortcut: "",
      onClick: () => {
        logout.handleLogout();
      },
      destructive: true,
    },
  ];

  return (
    <>
      <DynamicPopover
        className="w-60"
        side="right"
        align="end"
        trigger={
          <div className="cursor-pointer">
            {account && agent && (
              <AccountCard
                email={account.email}
                name={subName}
                avatar={agent?.subAvatar}
                compact={true}
                size="lg"
              />
            )}
          </div>
        }
        triggerHidden={false}
        mode="click"
      >
        {account && agent && (
          <UserInfo
            email={account.email}
            username={subName}
            avatar={agent?.subAvatar}
            onClick={() => setAccountModalOpen(true)}
          />
        )}
        <Separator className="-mx-1 my-1 h-px bg-muted" />
        <MenuOptions menuOptions={menuOptions} />
      </DynamicPopover>
      {/* 账户设置弹窗 */}
      <SettingsAccountModal
        open={accountModalOpen}
        onOpenChange={setAccountModalOpen}
        agent={agent}
        isSubscribed={isSubscribed}
      />
    </>
  );
}
